import React, {FC, memo} from 'react';

// Import React Player
import ReactPlayer from 'react-player';
import { getPublicUrl } from '../../../../utils/ImageCacheService';
import parse from 'html-react-parser';
import styled from 'styled-components';
import { NewsItem } from '../../../../models/newsItem';

interface INewsAllDetails {
    item: NewsItem;
}

const Details: FC<INewsAllDetails> = ({item}) => {

    return (
        <>
            {
            item.video_link || item.image ? 
                <Wrapper>
                    {
                        item.image ? <img src={getPublicUrl(item.file_name)} alt={item.title} /> :  <ReactPlayer url={item.video_link} width='100%' />
                    }
                </Wrapper>
                
            : null
            }

            {item.body ? 
                <Wrapper>
                    {parse(`${item.body}`)}
                </Wrapper>
            : null}
        </>
    )
}

const Wrapper = styled.div`
    display: inline-block;
    margin-bottom: 30px;
    .ql-video {
        max-width: 100%;
    }
`;


export default memo(Details);